import { useContext } from "react";
import { SideMenuContext } from "./SideMenuContext";

export const useSideMenuContext = () => useContext(SideMenuContext);
